import React, {useState, useRef, useEffect} from 'react';
import firebase from 'firebase';

import * as dataManager from '../adapters/data';

import { Button, Dropdown, Input, Modal } from 'semantic-ui-react';


const ConfirmDeleteModal = (props) => {

    const modalRef = useRef(null);

    const [name, setName] = useState('');
    const [qualifications, setQualifications] = useState([]);

    const deleteEntry = (type='employee') => {

        if (type == 'employee') {
            deleteEmployee();
        }

        else if (type == 'position') {
            deletePosition();
        }
        else if (type == 'qualification') {
            deleteQualification();
        }

    }

    useEffect( () => {
        if (props.show) {
            modalRef.current.focus();
        }

    }, [props.show]
    );


    const deleteEmployee = () => {

        console.log('Employee Deleted');
        props.onClose();

        dataManager.deleteEmployee(props.id);

        props.refreshListCb();

    }

    const deletePosition = () => {

        console.log('Position Deleted');
        props.onClose();

        dataManager.deletePosition(props.id);

        props.refreshListCb();

    }

    const deleteQualification = () => {
        console.log('Qualification Deleted');
        props.onClose();

        dataManager.deleteQualification(props.id);

        props.refreshListCb();
    }

    const updateName = (e) => {
        setName(e.target.value);
    }
    
    const updateQuals = (e, data) => {
        setQualifications(data.value);
        console.log(data.value);
    }
    
    return (
        <div>

            <Modal dimmer='blurring' open={props.show} role={`Delete ${props.name} dialog.`}
            >
            <Modal.Header>{props.header} </Modal.Header>
            <Modal.Content>
                <p>Are you sure you want to delete <b>{props.name}</b> {props.message}</p>
            </Modal.Content>
            <Modal.Actions>
                <Button ref={modalRef} color='blue' onClick={props.onClose} >
                Cancel
                </Button>
                <Button negative onClick={() => {deleteEntry(props.type)}} >
                Delete
                </Button>
            </Modal.Actions>
            </Modal>
        </div>
    );
};

export default ConfirmDeleteModal;